import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}

import useShoppingCartStore from '@/store/shopping-cart';
import { onMounted, watch } from 'vue';
import { useTelegramWebApp } from '@/services/telegram-web-app';
import { useRouter } from 'vue-router';
import AppBtn from '@/components/AppBtn.vue';
import { useI18n } from 'vue-i18n';
import { onUnmounted } from '@vue/runtime-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomBtn',
  setup(__props) {

const shoppingCartStore = useShoppingCartStore();
const telegramWebApp = useTelegramWebApp();
const router = useRouter();
const i18n = useI18n();

const onMainBtnClick = () => {
  router.push({ name: 'cart' });
};

const showMainBtn = () => {
  telegramWebApp.showMainBtn(
    `${i18n.t('goToOrder')} - ${shoppingCartStore.totalQuantity}`,
    onMainBtnClick,
  );
};

watch(() => shoppingCartStore.totalQuantity, () => {
  if (shoppingCartStore.totalQuantity > 0) {
    showMainBtn();
  } else {
    telegramWebApp.hideMainBtn();
  }
});
const showBtn = !telegramWebApp.isMainBtnAvailable();

onMounted(() => {
  if (shoppingCartStore.totalQuantity > 0) {
    showMainBtn();
  }
});
onUnmounted(() => telegramWebApp.removeMainBtnHandler(onMainBtnClick));

return (_ctx: any,_cache: any) => {
  return showBtn
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(AppBtn, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('goToOrder')), 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})